<template>

    <button 
        class="woocommerce-button button ad_button"
        :class="{ 'ad_button--loading' : loading }"
        :disabled="loading"
     >

        <slot></slot>

    </button>    

</template>

<script>

export default {

    props: {
        loading: {
            default: false
        }
    }
}

</script>

<style scoped>

.ad_button {
    position: relative;
    cursor: pointer;
}

.ad_button.ad_button--loading {
    padding-right: 3rem !important;
    transition: padding-right 0.1s;
    transition-timing-function: ease-in;
}

.ad_button.ad_button--loading::after {
    content: "";
    position: absolute;
    width: 16px;
    height: 16px;
    top: 0;
    right: 0.75rem;
    bottom: 0;
    margin: auto;
    border: 4px solid transparent;
    border-top-color: rgba(255, 255, 255, 1);
    border-radius: 50%;
    animation: button-loading-spinner 1s ease infinite;
}

@keyframes button-loading-spinner {
    from {
        transform: rotate(0turn);
    }

    to {
        transform: rotate(1turn);
    }
}


</style>